import AdminWithdrawalsScreen from '../../src/screens/AdminWithdrawalsScreen';

export default function AdminWithdrawalsRoute() {
  return <AdminWithdrawalsScreen />;
}
